import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL || window.location.origin;

const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
});

export default socket;
